import { combineReducers } from "redux";

import controlInfinitiveScrolling from "./controlInfinitiveScrolling";


const controlInfinitiveScrollingReducer = combineReducers({
    controlInfinitiveScrolling,
});

export default controlInfinitiveScrollingReducer;
